import React from 'react';

import ProjectsListComponent from 'components/Projects/ProjectsList';

const ProjectsList: React.FC = () => <ProjectsListComponent />;

export default ProjectsList;
